import { EntityContentBlueprint } from '@backstage/plugin-catalog-react/alpha';
import type { ExtensionDefinition } from '@backstage/frontend-plugin-api';

export const entityContentMeetingToolkit: ExtensionDefinition =
  EntityContentBlueprint.make({
    name: 'meeting-toolkit',
    params: {
      path: '/meeting-toolkit',
      title: 'Meeting Toolkit',
      filter: { kind: 'Group' },
      loader: () =>
        import('./meeting-toolkit-page').then(m => (
          <m.EntityMeetingToolkitPage />
        )),
    },
  });
